import { SYNTHETIC_TYPES } from './constants';
export var isPropagationStopped = {};
SYNTHETIC_TYPES.forEach(function (type) {
    isPropagationStopped[type] = false;
});
/**
 * 检查父元素里还有没有点击事件
 *
 * @export
 * @param {VNode} node
 * @returns
 */
export function validate(node, eventType) {
    var _a;
    var parent = node.parent;
    if (!parent) {
        isPropagationStopped[eventType] = false;
        return;
    }
    if ((_a = parent.props) === null || _a === void 0 ? void 0 : _a[eventType]) {
        return;
    }
    validate(parent, eventType);
}
export default function stopPropagation(node, eventType) {
    isPropagationStopped[eventType] = true;
    validate(node, eventType);
}
